import React, { useState, useEffect } from 'react';
import { 
    Spinner, Card, CardBody, Typography, Button, 
    Dialog, DialogHeader, DialogBody, DialogFooter,
    Input, IconButton, Tooltip, Textarea
} from "@material-tailwind/react";
import Axios from 'axios';
import Main from './Main';
import { transformarFechaTramiteSimple } from '../Helpers/fechas';
import Swal from 'sweetalert2';
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/solid";

export default function Delegados({ usuario }) {
    const [datos, setDatos] = useState([]);
    const [buscandoDatos, setBuscandoDatos] = useState(false);
    const [misIglesias, setMisIglesias] = useState([]);
    
    const [openDialog, setOpenDialog] = useState(false);
    const [editando, setEditando] = useState(false);
    const [dataValues, setDataValues] = useState({
        id_iglesia_delegado: null,
        nombre: '',
        apellido: '',
        nro_documento: '',
        id_iglesia: '',
        observaciones: ''
    });

    // Para manejo de tamaño de Dialog responsivo
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        obtenerIglesiasObrero();
        obtenerDatos();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const obtenerDatos = async () => {
        setBuscandoDatos(true);
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/delegados/ministro/${usuario.id_obrero}`);
            setDatos(data);
        } catch (err) {
            console.error("Error al obtener delegados:", err);
        } finally {
            setBuscandoDatos(false);
        }
    };

    const obtenerIglesiasObrero = async () => {
        setBuscandoDatos(true);
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/iglesiasobreroall/${usuario.id_obrero}`);
            setMisIglesias(data.filter(i => i.id_tipo_iglesia == 1));
        } catch (err) {
            console.error("Error al obtener iglesias:", err);
        } finally {
            setBuscandoDatos(false);
        }
    };

    const deleteDelegado = async (id_iglesia_delegado) => {
        const result = await Swal.fire({
            title: '¿Confirma la eliminación?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await Axios.delete(`api/tablasgenerales/iglesiadelegado/${id_iglesia_delegado}`);
                Swal.fire('Operación confirmada', 'Delegado eliminado.', 'success');
                obtenerDatos();
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar.', 'error');
            }
        }
    };

    const handleOpenDialog = (delegado = null, idIglesia = null) => {
        if (delegado) {
            setEditando(true);
            setDataValues({
                id_iglesia_delegado: delegado.id_iglesia_delegado,
                nombre: delegado.nombre,
                apellido: delegado.apellido,
                nro_documento: delegado.nro_documento,
                id_iglesia: delegado.id_iglesia,
                observaciones: delegado.observaciones || ''
            });
        } else {
            setEditando(false);
            setDataValues({
                id_iglesia_delegado: null, nombre: '', apellido: '', nro_documento: '',
                id_iglesia: idIglesia, observaciones: ''
            });
        }
        setOpenDialog(true);
    };

    const handleDataChanges = (e) => {
        const { name, value } = e.target;
        setDataValues({ ...dataValues, [name]: value });
    };

    const submitDelegado = async () => {
        const { nombre, apellido, nro_documento, id_iglesia } = dataValues;
        if (!nombre || !apellido || !nro_documento || !id_iglesia) {
            return Swal.fire("Error", "Complete los campos obligatorios", "error");
        }

        try {
            if (editando) {
                await Axios.put(`/api/tablasgenerales/iglesiadelegado/${dataValues.id_iglesia_delegado}`, dataValues);
            } else {
                await Axios.post(`/api/tablasgenerales/iglesiadelegado`, dataValues);
            }
            setOpenDialog(false);
            obtenerDatos();
            Swal.fire("Operación confirmada", "Se guardaron los datos.", "success");
        } catch (error) {
            Swal.fire("Error al procesar solicitud",error.response.data.message || "Ocurrió un error inesperado",'error');
        }
    };

    if (buscandoDatos) return <Main center alinear><Spinner className="h-12 w-12" /></Main>;

return (
    <Main>
        <div className="container mx-auto px-4 pb-10">
            {/* TÍTULO Y SUBTÍTULO */}
            <div className="text-center my-6">
                <Typography variant="h4" color="blue-gray" className="font-bold tracking-tight">
                    Delegados por Iglesia Autónoma
                </Typography>
            </div>

            <div className="w-full lg:w-[80%] mx-auto">
                {misIglesias.map(iglesia => {
                    const delegados = datos.filter(d => d.id_iglesia === iglesia.id_iglesia);
                    // Lógica de validación: ¿Cupo lleno?
                    const alcanzadoMaximo = delegados.length >= 1;

                    return (
                        <div key={iglesia.id_iglesia} className="mb-12 animate-fade-in">
                            
                            {/* HEADER SECCIÓN CON BOTÓN BLOQUEABLE */}
                            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end mb-4 gap-4 px-1">
                                <div>
                                    <Typography variant="h5" color="blue-gray" className="font-bold leading-tight">
                                        {iglesia?.iglesia}
                                    </Typography>
                                    <Typography variant="small" className="font-normal text-gray-500">
                                        {iglesia?.localidad}
                                    </Typography>
                                </div>

                                <Tooltip 
                                    content="Máximo 1 por iglesia" 
                                    placement="top"
                                    disabled={!alcanzadoMaximo}
                                >
                                    <div className={alcanzadoMaximo ? "cursor-not-allowed w-full sm:w-auto" : "w-full sm:w-auto"}>
                                        <Button 
                                            size="sm" 
                                            color="blue"
                                            className="flex items-center gap-2 normal-case w-full justify-center" 
                                            onClick={() => handleOpenDialog(null, iglesia.id_iglesia)}
                                            disabled={alcanzadoMaximo}
                                        >
                                            <PlusIcon className="h-4 w-4" /> Agregar Delegado
                                        </Button>
                                    </div>
                                </Tooltip>
                            </div>

                            {/* VISTA DESKTOP (TABLA) */}
                            <Card className="hidden md:block shadow-sm border border-gray-200 overflow-hidden">
                                <CardBody className="p-0">
                                    <table className="w-full table-auto text-left">
                                        <thead>
                                            <tr className="bg-gray-50 border-b border-gray-100">
                                                {['Nombre y Apellido', 'DNI', 'Fecha Alta', 'Acciones'].map((head) => (
                                                    <th key={head} className="py-3 px-4">
                                                        <Typography variant="small" className="font-bold text-blue-gray-400 uppercase text-[11px]">
                                                            {head}
                                                        </Typography>
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {delegados.length === 0 ? (
                                                <tr><td colSpan={4} className="py-10 text-center text-gray-400 italic text-sm">Sin delegados registrados.</td></tr>
                                            ) : (
                                                delegados.map((item) => (
                                                    <React.Fragment key={item.id_iglesia_delegado}>
                                                        <tr className="hover:bg-blue-gray-50/50 transition-colors">
                                                            <td className="py-3 px-4 border-b border-gray-50">
                                                                <Typography variant="small" className="font-medium text-blue-gray-800 uppercase">
                                                                    {item.nombre} {item.apellido}
                                                                </Typography>
                                                            </td>
                                                            <td className="py-3 px-4 border-b border-gray-50 text-sm text-blue-gray-600">{item.nro_documento}</td>
                                                            <td className="py-3 px-4 border-b border-gray-50 text-sm text-blue-gray-600">{transformarFechaTramiteSimple(item.fecha_alta)}</td>
                                                            <td className="py-3 px-4 border-b border-gray-50">
                                                                <div className="flex gap-1">
                                                                    <IconButton variant="text" size="sm" onClick={() => handleOpenDialog(item)}><PencilIcon className="h-4 w-4 text-blue-500" /></IconButton>
                                                                    <IconButton variant="text" size="sm" onClick={() => deleteDelegado(item.id_iglesia_delegado)}><TrashIcon className="h-4 w-4 text-red-500" /></IconButton>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        {item.observaciones && (
                                                            <tr>
                                                                <td colSpan={4} className="py-2 px-4 border-b border-gray-50 bg-gray-50/30 text-[11px] text-gray-500 italic">
                                                                    <span className="font-bold not-italic text-blue-gray-400 mr-1">OBS:</span> {item.observaciones}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </CardBody>
                            </Card>

                            {/* VISTA MOBILE (CARDS) */}
                            <div className="md:hidden flex flex-col gap-3">
                                {delegados.length === 0 ? (
                                    <div className="text-center py-6 bg-gray-50 rounded-lg border border-dashed border-gray-300 text-gray-400 text-sm">Sin delegados.</div>
                                ) : (
                                    delegados.map((item) => (
                                        <Card key={item.id_iglesia_delegado} className="shadow-sm border border-gray-200">
                                            <CardBody className="p-4">
                                                <div className="flex justify-between items-start">
                                                    <div className="flex-1">
                                                        <Typography className="font-bold text-blue-gray-800 uppercase text-sm">
                                                            {item.nombre} {item.apellido}
                                                        </Typography>
                                                        <Typography className="text-xs text-gray-500 mt-1">
                                                            DNI: {item.nro_documento} • Alta: {transformarFechaTramiteSimple(item.fecha_alta)}
                                                        </Typography>
                                                    </div>
                                                    <div className="flex gap-1 ml-2">
                                                        <IconButton variant="text" size="sm" onClick={() => handleOpenDialog(item)} className="bg-blue-50/50"><PencilIcon className="h-4 w-4 text-blue-500" /></IconButton>
                                                        <IconButton variant="text" size="sm" onClick={() => deleteDelegado(item.id_iglesia_delegado)} className="bg-red-50/50"><TrashIcon className="h-4 w-4 text-red-500" /></IconButton>
                                                    </div>
                                                </div>
                                                {item.observaciones && (
                                                    <div className="mt-3 p-2 bg-gray-50 rounded text-[11px] italic text-gray-600 border-l-2 border-blue-gray-100">
                                                        {item.observaciones}
                                                    </div>
                                                )}
                                            </CardBody>
                                        </Card>
                                    ))
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>

        {/* DIALOGO RESPONSIVO PROTEGIDO */}
        <Dialog 
            open={openDialog} 
            handler={() => {}} // Evita cierre accidental por clicks externos o Swals
            size={isMobile ? "xxl" : "xs"} 
            className="md:shadow-2xl"
        >
            <DialogHeader className="text-blue-gray-800 font-bold border-b border-gray-100">
                {editando ? 'Editar Delegado' : 'Nuevo Delegado'}
            </DialogHeader>
            <DialogBody className="flex flex-col gap-5 py-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <Input label="Nombre" name="nombre" value={dataValues.nombre} onChange={handleDataChanges} color="blue" />
                    <Input label="Apellido" name="apellido" value={dataValues.apellido} onChange={handleDataChanges} color="blue" />
                </div>
                <Input label="DNI" name="nro_documento" type="number" value={dataValues.nro_documento} onChange={handleDataChanges} color="blue" />
                <Textarea label="Observaciones" name="observaciones" value={dataValues.observaciones} onChange={handleDataChanges} color="blue" rows={3} />
            </DialogBody>
            <DialogFooter className="gap-2 border-t border-gray-100">
                <Button variant="text" color="red" onClick={() => setOpenDialog(false)} className="flex-1 sm:flex-none">Cancelar</Button>
                <Button variant="gradient" color="blue" onClick={submitDelegado} className="flex-1 sm:flex-none">Guardar</Button>
            </DialogFooter>
        </Dialog>
    </Main>
);
}